import React from 'react'
import styled from 'styled-components'
import QRCode from 'react-qr-code'

import Button from 'components/reusable/button'
import SvgCrossMarkOutlineV2 from 'components/reusable/svg/svg_cross_mark_outline_v2'
import Image from 'components/reusable/image'
import { colors } from 'helpers/colors'
import { H3, H6, BodyMain } from 'components/views/help/help_faq_v2/components/styled'
import Settings from 'helpers/settings'

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  width: 100%;
  position: relative;
  overflow: hidden;
  border-radius: 24px;
`

const StyledButton = styled(Button)`
  box-shadow: 0 1px 4px 0 rgba(31, 30, 30, 0.12);
  background-color: ${colors.white};
  border-radius: 50%;
  position: absolute;
  top: 16px;
  right: 16px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;

  @media (max-width: 1440px) {
    width: 32px;
    height: 32px;
  }
`

const LeftWrapper = styled.div`
  width: 460px;

  @media (max-width: 1440px) {
    width: 400px;
  }
  @media (max-width: 1200px) {
    width: 360px;
  }
  @media (max-width: 960px) {
    display: none;
  }
`

const RightWrapper = styled.div`
  width: 600px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 48px;
  gap: 32px;

  @media (max-width: 1440px) {
    padding: 32px;
    width: 560px;
    gap: 24px;
  }
  @media (max-width: 1200px) {
    width: 500px;
  }
  @media (max-width: 768px) {
    width: 100%;
    padding: 48px 48px 24px;
  }
`

const StyledImage = styled(Image)`
  height: 100%;
  object-fit: cover;
`

const ListWrapper = styled.div``

const List = styled.ul`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const ListItem = styled.li``

const QrCodeWrapper = styled.div`
  padding: 40px;
  background-color: ${colors.gray[50]};
  border-radius: 20px;
  border: 1px solid ${colors.gray[100]};
`

const features = ['Get instant notifications', 'Message talent directly', 'Book on the move']

const AppViewApplicantsModal = ({ onClose }) => {
  return (
    <Wrapper>
      <LeftWrapper>
        <StyledImage src="/images/modals/app_view_applicants.jpg" alt="app-view-applicants" />
      </LeftWrapper>

      <RightWrapper>
        <StyledButton type="semantic-wrapper" onClick={onClose} aria-label="Close">
          <SvgCrossMarkOutlineV2 size={14} color={colors.gray[700]} />
        </StyledButton>

        <H3 weight={500} textAlign="center">
          Track Applicants on the Go
        </H3>

        <ListWrapper>
          <H6>Download the Swipecast app to:</H6>
          <List>
            {features.map((feature) => (
              <ListItem key={feature}>
                <BodyMain>{feature}</BodyMain>
              </ListItem>
            ))}
          </List>
        </ListWrapper>

        <QrCodeWrapper>
          <QRCode size={200} value={Settings.appURL} viewBox={`0 0 256 256`} />
        </QrCodeWrapper>
      </RightWrapper>
    </Wrapper>
  )
}

export default AppViewApplicantsModal
